import {TARIFF} from './userFilters';

export function getLeafTariffIds(selected: string[]): string[] {
    if (!selected || selected.length === 0) return [];
    const leafIds = new Set<string>();
    const parentById = new Map<string, { id: string; children?: { id: string }[] }>();
    const childIdsByParent = new Map<string, string[]>();
    const isChildId = new Set<string>();
    TARIFF.forEach(p => {
        parentById.set(p.id, p);
        if (p.children && p.children.length) {
            const ids = p.children.map(c => c.id);
            childIdsByParent.set(p.id, ids);
            ids.forEach(id => isChildId.add(id));
        }
    });
    selected.forEach(id => {
        if (parentById.has(id)) {
            const kids = childIdsByParent.get(id) || [];
            kids.forEach(k => leafIds.add(k));
            return;
        }
        if (isChildId.has(id)) {
            leafIds.add(id);
            return;
        }
        leafIds.add(id);
    });
    return Array.from(leafIds);
}
